// extracted by mini-css-extract-plugin
export var PageLayout = "PageLayout-module--PageLayout--XUCyz";
export var PageLayout_content = "PageLayout-module--PageLayout_content--ffzIi";
export var PageLayout_content_withBanner = "PageLayout-module--PageLayout_content_withBanner--vAzYd";
export var PageLayout_header = "PageLayout-module--PageLayout_header--aDuIH";